<template>
  <div class="catalog_module">
    <div class="search flex">
      <span class="tit">三级字典管理-{{ catalogName }}</span>
    </div>
    <el-container>
      <el-aside width="220px">
        <ul class="aside-ul">
          <li v-for="item in itemList"
              :key="item.id"
              class="aside-li"
              @click="changeItem(item)"
              :active="curItem.id===item.id?'1':'0'">
            <span>{{ item.itemName }}</span>
          </li>
        </ul>
      </el-aside>
      <el-main>
        <div class="dict-info flex">
          <div>
            <p>
              <span class="title">
                <label>字典名称:</label>
                {{ curItem.itemName }}
              </span>
              <span class="title">
                <label>字典代码:</label>
                {{ curItem.itemCode }}
              </span>
            </p>
            <p>
              <label>描述:</label>
              {{ curItem.itemDesc ? curItem.itemDesc : '-' }}
            </p>
            <p>
              <label>备注:</label>
              {{ curItem.remark ? curItem.remark : '-' }}
            </p>
          </div>
          <div class="dict-operate">
            <el-button type="primary" size="small" style="color: #FFFFFF" class="addBtn" @click="editItem(0)">
              新增子项
            </el-button>
          </div>
        </div>
        <el-table :data="subitemList"
                  :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                  height="calc(100vh - 400px)" class="record-table"
                  max-height="calc(100vh - 400px)">
          <el-table-column type="expand" align="center">
            <template slot-scope="props">
              <p>
                <label class="title">
                  icon:
                </label>
                {{ props.row.subIcon ? props.row.subIcon : '-' }}
              </p>
              <p>
                <label class="title">
                  描述:
                </label>
                {{ props.row.subDesc ? props.row.subDesc : '-' }}
              </p>
              <p>
                <label class="title">
                  备注:
                </label>
                {{ props.row.remark ? props.row.remark : '-' }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="排序" property="subSort" align="center"></el-table-column>
          <el-table-column label="子项名称" show-overflow-tooltip prop="subName" align="center"></el-table-column>
          <el-table-column label="代码" prop="subCode" align="center"></el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <el-button slot-scope="scope"
                       :state="scope.row.status"
                       @click="changeStatus(scope.row)"
                       type="text"
                       size="small">
              {{ scope.row.status === 0 ? '禁用' : '启用' }}
            </el-button>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.subType===1">
                <el-button @click="editItem(scope.row)"
                           type="text"
                           size="small">
                  编辑
                </el-button>
                <el-popconfirm
                    confirm-button-text='好的'
                    cancel-button-text='不用了'
                    icon="el-icon-info"
                    icon-color="red"
                    @confirm="del(scope.row.id)"
                    title="确定删除吗？">
                  <el-button slot="reference" class="btn" type="text" size="small">删除</el-button>
                </el-popconfirm>
              </template>
              <span v-else
                    class="disabled-tips">
                系统字段无法修改
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>

    </el-container>

    <!--    抽屉 start -->
    <el-drawer :visible.sync="editDialog.visible"
               :wrapper-closable="false"
               :show-close="false"
               :title="(editDialog.mode==='add'?'新增':'编辑')+'子项'"
               size="700px"
               class="drawerCommon">
      <el-form :model="curSubitem"
               label-suffix=": "
               label-width="90px"
               class="maxHeight">
        <el-form-item label="子项名称">
          <el-input v-model="curSubitem.subName"></el-input>
        </el-form-item>
        <el-form-item label="代码">
          <el-input v-model="curSubitem.subCode"></el-input>
        </el-form-item>
        <el-form-item label="icon">
          <el-upload class="avatar-uploader"
                     :action="iconUploadUrl"
                     :show-file-list="false"
                     name="uploadFile"
                     :on-success="handleIconSuccess">
            <img v-if="curSubitem.subIcon" :src="curSubitem.subIcon" alt="" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" rows="4" v-model="curSubitem.subDesc"></el-input>
        </el-form-item>
        <el-form-item label="排序" v-if="editDialog.mode !== 'add'">
          <el-input-number v-model="curSubitem.subSort" :step="1" step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea"
                    rows="4"
                    v-model="curSubitem.remark"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" type="primary" @click="saveItem">保存</el-button>
        <el-button size="small" @click="editDialog.visible=false">取消</el-button>
      </div>
    </el-drawer>
    <!--    抽屉 end-->
  </div>
</template>

<script>
import base from "../../../api/common";

export default {
  name: "itemList",
  data() {
    return {
      searchKey: '',
      curItem: {
        id: '',
        itemCode: '',
        itemName: '',
        itemIcon: '',
        itemDesc: '',
        remark: '',
        sort: 0,
      },

      catalogId: this.$route.query.id || '',
      catalogName: this.$route.query.name || '',
      itemList: [],

      curSubitem: {
        id: '',
        itemId: '',
        remark: '',
        status: '',
        subCode: '',
        subDesc: '',
        subIcon: '',
        subName: '',
        subSort: 0,
        subType: ''
      },
      subitemList: [],

      editDialog: {
        visible: false,
        mode: 'add',
      },
      iconUploadUrl: base.uploadUrl + 'sub',


    }
  },
  mounted() {
    let that = this;
    that.$ajax.get(base.api.dict.edit.item.list.replace("{catalogId}", that.catalogId)).then((res) => {
      if (res.data.status === 'success') {
        that.itemList = res.data.list;
        if (res.data.list.length > 0) {
          that.changeItem(res.data.list[0])
        }
      }
    });
  },
  methods: {
    //改变二级子项选择
    changeItem(item) {
      if (item && item.id) {
        let that = this;
        that.curItem = item;
        that.$ajax.get(base.api.dict.edit.sub.list.replace("{itemId}", item.id)).then((res) => {
          if (res.data.status === 'success') {
            that.subitemList =res.data.list;
          }
        })
      }
    },
    changeStatus(obj) {
      if (obj && obj.id) {
        let that = this;
        let status = (obj.status + 1) % 2;
        that.$messageBox.confirm("确定要" + (status === 1 ? "启用" : "禁用") + "吗?", "状态确认", {type: "warning"}).then(() => {
          that.$ajax.get(base.api.dict.edit.sub.updateStatus.replace("{id}", obj.id).replace("{status}", status)).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success('操作成功');
              obj.status = status;
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error("操作失败!");
          })
        })
      }
    },
    editItem(obj) {
      let that = this;
      if (obj.id) { // 编辑
        that.editDialog.mode = 'edit';
        that.curSubitem.id = obj.id;
        that.curSubitem.itemId = that.curItem.id;
        that.curSubitem.subCode = obj.subCode;
        that.curSubitem.subName = obj.subName;
        that.curSubitem.subIcon = obj.subIcon;
        that.curSubitem.subDesc = obj.subDesc;
        that.curSubitem.remark = obj.remark;
        that.curSubitem.subSort = obj.subSort;
      } else { // 新增
        that.editDialog.mode = 'add';
        that.curSubitem.id = '';
        that.curSubitem.itemId = that.curItem.id;
        that.curSubitem.subCode = '';
        that.curSubitem.subName = '';
        that.curSubitem.subIcon = '';
        that.curSubitem.subDesc = '';
        that.curSubitem.remark = '';
        that.curSubitem.subSort = 0;
      }
      that.editDialog.visible = true;
    },
    handleIconSuccess(res, file) {
      let that = this;
      if (res.status === 'success') {
        that.curSubitem.subIcon = res.message;
      }
    },
    saveItem() {
      let that = this;
      let url = base.api.dict.edit.sub.save;
      if (that.editDialog.mode === 'edit') {
        url = base.api.dict.edit.sub.update;
      }
      that.$ajax.post(url, that.curSubitem).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功')
          that.changeItem(that.curItem)
          that.editDialog.visible = false;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败')
      })
    },
    del(id) {
      let that = this;
      this.$ajax.get(base.api.dict.edit.sub.delete.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success('操作成功');
          that.changeItem(that.curItem)
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.catalog_module {
  ::v-deep .el-main {
    height: calc(100vh - 240px);
    min-height: 480px;
  }
}

.aside-ul {
  padding: 0;

  li.aside-li {
    height: 28px;
    line-height: 28px;
    margin: 10px 0;
    padding-left: 40px;
    text-align: left;
    font-size: 14px;
    color: rgb(42, 45, 46);
    cursor: pointer;
  }

  li.aside-li[active='1'] {
    font-weight: 700;
    color: rgb(86, 124, 255);
  }
}

.dict-info {
  padding: 10px 20px;
  position: relative;
  justify-content: space-between;
  align-items: normal;
  font-size: 14px;

  p {
    line-height: 20px;
    margin: 10px 0;

    color: #5e6d82;

    span.title {
      display: inline-block;
      width: 300px;
    }
  }

  ::v-deep label {
    font-size: 16px;
    font-weight: 700;
    color: #1f2f3d;
    margin: 10px 20px 10px 0;
  }

  /* ::v-deep span, p {

   }*/

  /*.dict-operate {
    position: absolute;
    right: 40px;
    top: 20px;

    button {
      padding: 0;
      width: 86px;
      height: 32px;
    }
  }*/
}

button[state='0'] {
  color: #f56c6c
}

button[state='1'] {
  color: #67c23a
}

span.disabled-tips {
  font-size: 12px;
  color: #f56c6c;
  cursor: not-allowed;
}

label.title {
  margin-right: 10px;
  font-weight: 700
}
</style>